import { render } from "./UserProfilesConfiguration.vue?vue&type=template&id=4ed3e781&ts=true"
import script from "./UserProfilesConfiguration.vue?vue&type=script&lang=ts"
export * from "./UserProfilesConfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__